// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3TaIU","options":"AnswerScale_options__3ddzU","selected":"AnswerScale_selected__3obma"};